import { Component } from 'react';
import lodash from 'lodash';

import { Button, BUTTON } from 'components/common/Button/Button';
const { COLOR, BGCOLOR } = BUTTON;
import DateTime from 'common/components/DateTime/DateTime';
import DocumentAttributes from 'part11/components/Document/DocumentAttributes/DocumentAttributes';

import styles from './DocumentRow.scss';
import { FILED, UNFILED } from 'common/util/filingHelpers';


export default class DocumentRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isExpanded: props.expand
        };
    }

    getDocumentStatus(document, type) {
        if(type !== 'filed') {
            return getUnfiledDocumentStatus(document);
        }
        
        return getFiledDocumentStatus(document);
    }

    renderSimpleRow() {
        const { document, type, openFilePicker, onfile, documentTypeId } = this.props;
        const documentStatus = this.getDocumentStatus(document, type);
        const conversionStatus = lodash.get(document, 'status', null);
        const isUnconverted = conversionStatus === 'new';
        const isUnfiledRow = type === 'unfiled';
        

        return (
            <div className={`${styles.DocumentRow} ${documentStatus.indicatorStyle}`} data-cy="DocumentRow">
                <div className={styles.rowContainer}>
                    <div className={styles.left}>
                        <span className={documentStatus.labelStyle} onClick={() => openFilePicker()} data-cy="DocumentRow-label">{documentStatus.label}</span>
                    </div>
                    <div className={styles.right}>
                        {isUnfiledRow && !isUnconverted && 
                            <Button 
                                text={'File'}
                                color={COLOR.BLUE}
                                onClick={() => onfile(document, UNFILED, documentTypeId)} 
                                data-cy="DocumentRow-Button"/>}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { document, index, onDocumentClick, onfile, type } = this.props;
        const { isExpanded } = this.state;
        const documentStatus = this.getDocumentStatus(document, type);

        if(type !== 'filed') {
            return this.renderSimpleRow();
        }

        return (
            <div className={`${styles.DocumentRow} ${documentStatus.indicatorStyle}`} data-cy="DocumentRow-render">
                <div className={styles.rowContainer}>
                    <div  className={styles.left}>
                        <span className={styles.documentCount} data-cy="DocumentRow-index">{index + 1}</span>
                        <span className={`${styles.filedDocumentLabel} `} onClick={() => onDocumentClick(document)} data-cy="DocumentRow-name">{document.name}</span>
                    </div>
                    <div className={styles.right}>
                        <span className={documentStatus.pillStyle} data-cy="DocumentRow-label">{documentStatus.label}</span>
                        <Button 
                            onClick={() => this.setState({isExpanded: !isExpanded})}
                            text={isExpanded ? 'Close' :'Open'}
                            color={isExpanded ? COLOR.GREY : COLOR.BLUE}
                            data-cy="DocumentRow-setState"/>
                    </div>
                </div>
                {isExpanded && 
                        <div className={styles.rowExpanded}>
                            <div className={styles.documentAttributes}>
                                <span className={documentStatus.textStyle} data-cy="DocumentRow-text">{documentStatus.text}</span>
                                <DocumentAttributes document={document.document} />
                            </div>
                            <div className={styles.documentActions}>
                                <Button 
                                    text={'Refile'}
                                    color={COLOR.WHITE}
                                    bgcolor={BGCOLOR.BLUE}
                                    onClick={() => onfile(document, FILED)} 
                                    data-cy="DocumentRow-Refile"/>
                            </div>
                        </div>
                }
            </div>
        );
    }
}

const getUnfiledDocumentStatus = (document) => {
    const conversionStatus = lodash.get(document, 'status', null);
    if (!conversionStatus) {
        return {
            indicatorStyle: styles.missingIndicator,
            label: 'Add Document',
            labelStyle: styles.missingDocumentLabel
        };
    }
    if(conversionStatus === 'new') {
        return {
            indicatorStyle: styles.conversionInProgressIndicator,
            label: document.name,
            labelStyle: styles.convertedDocumentLabel
        };
    }
    if(conversionStatus === 'success') {
        return {
            indicatorStyle: styles.conversionSuccessIndicator,
            label: document.name,
            labelStyle: styles.convertedDocumentLabel
        };
    }
    if(conversionStatus === 'failed') {
        return {
            indicatorStyle: styles.conversionFailedIndicator,
            label: document.name,
            labelStyle: styles.unconvertedDocumentLabel
        };
    }
};

const getFiledDocumentStatus = (document) => {
    const { expirationDate, daysTilExpiration } = document;
    if(document.isExpired) {
        return {
            label: 'EXPIRED',
            indicatorStyle: styles.expiredIndicator,
            pillStyle: styles.expiredPill,
            textStyle: styles.expiredText,
            text: <span>Expired on <DateTime value={expirationDate} format={'MMM DD, YYYY'} /></span>
        };
    }
    if(document.isExpiringSoon) {
        return {
            label: 'EXPIRING',
            indicatorStyle: styles.expiringIndicator,
            pillStyle: styles.expiringPill,
            textStyle: styles.expiringText,
            text: `Expires in ${daysTilExpiration} days`
        };
    }
    if(document.isValid) {
        return {
            label: 'FILED',
            indicatorStyle: styles.filedIndicator,
            pillStyle: styles.filedPill,
            textStyle: styles.filedText,
            text: daysTilExpiration ? `Expires in ${daysTilExpiration} days`: ''
        };
    }
};
